import { Helmet } from "react-helmet";
import ContainerHeaderLayout from "views/components/ContainerHeaderLayout/ContainerHeaderLayout";
import ModelTable from "./ModelTable";
import ValidationJobsTable from "./ValidationJobsTable";
import styles from "./style.module.scss";
import { useNavigate } from "react-router";
import { useFeatureFlagService } from "hooks/useFeatureFlagService";
import { MODELS_CATALOG } from "helpers/constants/filters";
import { useUserConfig } from "hooks/useUserConfig";
import VLColorfulLoader from "views/uikit/VLColorfulLoader";
import UnavailableModal from "views/components/UnavillableModal/UnavailableModal";
import { Tab } from "views/components/ContainerHeader/TabSwitch";
import { useTabSelection, modelCatalogeTabTypes } from "./useTabSelection";

export default function ModelCatalogPage() {
  const { isLoading: isConfigLoading, config: userConfig } = useUserConfig();
  const navigate = useNavigate();
  const isModelsCatalogEnabled = useFeatureFlagService(MODELS_CATALOG).enabled;
  const loading = userConfig.length === 0 || isConfigLoading;
  const { tabContent, selectedTab } = useTabSelection();

  return (
    <>
      <Helmet>
        <title>Model Catalog</title>
      </Helmet>
      <ContainerHeaderLayout
        upperRow={
          <div className={styles.pageHeader}>
            <div className={styles.pageTitle}>Models Catalog</div>
            <div className={styles.tabsContainer}>
              {tabContent.map((tab) => (
                <Tab
                  key={tab.key}
                  label={tab.label}
                  selected={tab.selected}
                  disabled={tab.disabled}
                  onClick={tab.onclick}
                  icon={tab.icon}
                  className={styles.singleTab}
                />
              ))}
            </div>
          </div>
        }
      />

      {loading ? (
        <VLColorfulLoader />
      ) : isModelsCatalogEnabled ? (
        <div className={styles.content}>
          {selectedTab === modelCatalogeTabTypes.TRAINING_JOBS ? (
            <ModelTable />
          ) : (
            <ValidationJobsTable />
          )}
        </div>
      ) : (
        <UnavailableModal
          onClose={() => navigate("/datasets")}
          actionText={"Go back to datasets page"}
        />
      )}
    </>
  );
}
